<div class="t-widget--noPadding t-widget--inverted">
  <header class="l-flex-column l-align-top summary-box-header">
    <h2 class="t-widgetTitle">
      {{ "translate.dashboard.newsTitle" | translate }}
    </h2>
    <hr />

    <div class="content-container">
      <div
        *ngFor="let i of data.news"
        class="content"
        [class.hidden]="i !== curNewsItem"
      >
        {{ i.text }}
      </div>
    </div>

    <div class="w-full l-align-spaceBetween l-align-center box-buttons">
      <div class="nav-container">
        <a *ngFor="let i of data.news" (click)="navNewsClicked(i)">
          <span class="nav-circle" [class.selected]="i == curNewsItem"></span>
        </a>
      </div>

      <button
        *ngIf="allowEdit"
        (click)="displayEditNews = true"
        class="t-button-outline btn-edit"
      >
        {{ "translate.dashboard.edit" | translate }}
      </button>
    </div>
  </header>
</div>

<modal-popup
  [flexible]="true"
  [hideHeader]="true"
  (onClose)="displayEditNews = false"
  [isOpen]="displayEditNews"
  [focusOnOpen]="false"
  [draggable]="false"
>
  <edit-news
    *ngIf="displayEditNews"
    class="t-scrollbar"
    (onCancel)="displayEditNews = false"
  ></edit-news>
</modal-popup>
